import { initializeStandaloneHelp as initialize, type StandaloneHelpPanel } from "./standalone-trigger";

/**
 * The Vite entry of the member app's server-rendered pages (login, second factor, error
 * pages): the lightweight trigger of ./standalone-trigger with the member articles, loaded
 * through ./standalone-panel on the first request only.
 */
export function initializeStandaloneHelp(container: HTMLElement, load: () => Promise<StandaloneHelpPanel> = () => import("./standalone-panel")) {
  return initialize(container, load);
}

const container = document.getElementById("page-help");
if (container) initializeStandaloneHelp(container);
